import { Stack } from "@mui/material";
import { useState } from "react";
import AssessmentReportSectionEditModal from "../common/EditSectionModal/assessment-report-tab";
import DataSection from "./sections/Data";
import TextSection from "./sections/Text";
import { AssessmentReportSectionId, TabProps } from "../types";
import type { EditSolutionFormValues } from "../../../edit/form/types";
import { createAssessmentReportSectionUpdatePayload } from "../common/EditSectionModal/assessment-report-tab/payload";
import ImagesSection from "./sections/Images";

function AssessmentReportTab({
  details,
  updateSolutionSection,
  updateLoading = false,
  updateAlert,
}: TabProps) {
  const [editingSection, setEditingSection] =
    useState<AssessmentReportSectionId | null>(null);
  const openSection = (section: AssessmentReportSectionId) =>
    setEditingSection(section);
  const closeSection = () => setEditingSection(null);
  const submitSection = async (values: EditSolutionFormValues) => {
    if (!updateSolutionSection || !editingSection) return false;

    try {
      const payload = createAssessmentReportSectionUpdatePayload(
        editingSection,
        values,
      );
      const result = await updateSolutionSection(payload);
      return result?.status === 204;
    } catch {
      return false;
    }
  };

  return (
    <Stack data-testid="assessment-report-tab" direction="column">
      <TextSection details={details} onEdit={openSection} />

      <ImagesSection details={details} onEdit={openSection} />

      <DataSection details={details} onEdit={openSection} />

      <AssessmentReportSectionEditModal
        section={editingSection}
        details={details}
        loading={updateLoading}
        error={updateAlert?.type === "error" ? updateAlert.message : undefined}
        onClose={closeSection}
        onSubmit={submitSection}
      />
    </Stack>
  );
}

export default AssessmentReportTab;
